var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDesktopPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 10,
  viewBox: "0 0 16 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.02 0v9.853h-1.997v-7.49l-1.279.396-1.344.005.2-1.309L13.894.12zM5 .9v2.999L8 3.9v2l-3-.001V8.9H3V5.899L0 5.9v-2l3-.001V.9z"
})));
export default SvgGoogleDesktopPlus;